import * as React from 'react';
import { SVGProps } from 'react';


const BrandWallet = (props: SVGProps<any>): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 26}
    height={props.height || 20}
    viewBox="0 0 26 20"
    fill="none"
    className={`dynamic-icon ${props.className}`}
    {...props}
  >
    <path
      d="M23 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H23C23.7956 20 24.5587 19.6839 25.1213 19.1213C25.6839 18.5587 26 17.7956 26 17V3C26 2.20435 25.6839 1.44129 25.1213 0.87868C24.5587 0.316071 23.7956 0 23 0ZM16 9C16 9.79565 15.6839 10.5587 15.1213 11.1213C14.5587 11.6839 13.7956 12 13 12C12.2044 12 11.4413 11.6839 10.8787 11.1213C10.3161 10.5587 10 9.79565 10 9C10 8.73478 9.89464 8.48043 9.70711 8.29289C9.51957 8.10536 9.26522 8 9 8H2V6H24V8H17C16.7348 8 16.4804 8.10536 16.2929 8.29289C16.1054 8.48043 16 8.73478 16 9ZM3 2H23C23.2652 2 23.5196 2.10536 23.7071 2.29289C23.8946 2.48043 24 2.73478 24 3V4H2V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2Z"
      fill="#003323"
    />
  </svg>
);

export default BrandWallet;
